import contentDisposition from "content-disposition";

export const downloadFile = async data => {
  const blob = await data.blob();
  let url = window.URL.createObjectURL(blob);
  let a = document.createElement("a");
  a.href = url;
  a.download = contentDisposition.parse(data.headers.get("content-disposition")).parameters.filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
};
